import React, { useRef } from 'react';

import ModalDirectors from './ModalDirectors';

import RodrigoBg from '../../../../../Images/modals/directors/rodrigo/bg_rodrigo.png';
import Video1 from '../../../../../Images/modals/directors/rodrigo/video-1.png';
import Video2 from '../../../../../Images/modals/directors/rodrigo/video-2.png';
import Video3 from '../../../../../Images/modals/directors/rodrigo/video-3.png';
import Video4 from '../../../../../Images/modals/directors/rodrigo/video-4.png';

import {
  Director_Rodrigo,
  Text_Rodrigo,
  TextVideo1_Rodrigo,
  TextVideo2_Rodrigo,
  TextVideo3_Rodrigo,
  TextVideo4_Rodrigo,
} from '../../../../../utils/ES/Modals/directors';

const ModalRodrigo = () => {
  return (
    <>
      <ModalDirectors
        id="director-rodrigo"
        mainBg={RodrigoBg}
        directorName={Director_Rodrigo}
        mainVideoBg={Video1}
        videoText1={TextVideo1_Rodrigo}
        directorText={Text_Rodrigo}
        rowImage1={Video2}
        videoText2={TextVideo2_Rodrigo}
        rowImage2={Video3}
        videoText3={TextVideo3_Rodrigo}
        rowImage3={Video4}
        videoText4={TextVideo4_Rodrigo}
        mainVideoLink={'rodrigo-video-1'}
        rowVideoLink1={'rodrigo-video-2'}
        rowVideoLink2={'rodrigo-video-3'}
        rowVideoLink3={'rodrigo-video-4'}
      />
    </>
  );
};

export default ModalRodrigo;
